import HCaptcha from "@hcaptcha/react-hcaptcha";
import config from "123tcs-common/config";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useEditorSettings } from "../../contexts/EditorSettings";
import Errors from "../Errors";
import SimulationTooltip from "../SimulationTooltip";
import { useSimulation } from "../../contexts/Simulation";

function BalanceCheckerForm(props) {
  const {
    id,
    cardNumber,
    setCardNumber,
    pinCode,
    setPinCode,
    setCaptchaToken,
    balanceChecker,
    onSubmit,
    errors,
  } = props;

  // Contexts
  const { t: translate } = useTranslation();
  const { settings } = useEditorSettings();
  const { simulateEditorSettings } = useSimulation();

  // Refs
  const captchaRef = useRef(null);

  // Functions
  const handleSumbit = async (event) => {
    event.preventDefault();
    onSubmit();
  };

  // Render
  return (
    <>
      <div className="title">
        <SimulationTooltip title=".title label">
          <label htmlFor="BalanceCheckerForm">
            {translate("balanceChecker")}
          </label>
        </SimulationTooltip>
      </div>

      {errors.length > 0 && <Errors errors={errors} />}

      <form id={id} onSubmit={handleSumbit}>
        {/* CARD NUMBER */}
        <div className="input-group form cardnumber">
          <SimulationTooltip title=".cardnumber label">
            <label htmlFor="CardNumber">{translate("cardNumber")}</label>
          </SimulationTooltip>

          <SimulationTooltip title=".cardnumber input">
            <input
              onChange={(event) => setCardNumber(event.target.value)}
              value={cardNumber}
              placeholder={translate("enterCardNumber")}
              className="CardNumber"
              type="text"
            />
          </SimulationTooltip>
        </div>

        {/* VERIFICATION CODE */}
        {(balanceChecker.useVerificationCode ||
          (simulateEditorSettings && settings.showVerificationCode)) && (
          <div className="input-group form ivc">
            <SimulationTooltip title=".ivc label">
              <label htmlFor="IVC">{translate("pinCode")}</label>
            </SimulationTooltip>

            <SimulationTooltip title=".ivc input">
              <input
                onChange={(event) => setPinCode(event.target.value)}
                value={pinCode}
                placeholder={translate("enterPinCode")}
                name="IVC"
                type="text"
              />
            </SimulationTooltip>
          </div>
        )}

        {/* CAPTCHA */}
        {(balanceChecker.useCaptcha ||
          (simulateEditorSettings && settings.showCaptcha)) && (
          <HCaptcha
            id="captcha"
            sitekey={config.captcha.sitekey}
            onVerify={setCaptchaToken}
            ref={captchaRef}
          />
        )}

        {/* SUBMIT BUTTON */}
        <div className="input-group form submit">
          <SimulationTooltip title="input.btn-submit">
            <input
              className="btn btn-submit"
              type="submit"
              value={translate("check")}
            />
          </SimulationTooltip>
        </div>
      </form>
    </>
  );
}

BalanceCheckerForm.propTypes = {
  id: PropTypes.string,
  cardNumber: PropTypes.string,
  setCardNumber: PropTypes.func.isRequired,
  pinCode: PropTypes.string,
  setPinCode: PropTypes.func.isRequired,
  setCaptchaToken: PropTypes.func.isRequired,
  balanceChecker: PropTypes.shape({
    useVerificationCode: PropTypes.bool,
    useCaptcha: PropTypes.bool,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf([]),
};

BalanceCheckerForm.defaultProps = {
  id: "BalanceCheckerForm",
  cardNumber: "",
  pinCode: "",
  errors: [],
};

export default BalanceCheckerForm;
